// @mui
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
// utils

// ----------------------------------------------------------------------

const RenderAddButton = ({ addLink, addButtonTite, permission, onClick }) => {
    const permissionArry = useSelector((state) => state.Login.permissionArry);

    const authorize = permissionArry?.includes(permission)
    if (!authorize) return null;
    return (
        <>
            {onClick ? <Button color="primary-button" type="button" onClick={onClick} className="waves-effect waves-light me-1 w-100">
                    <i className="ri-add-line align-middle me-2"></i>{addButtonTite}
                </Button> : <Link to={addLink} style={{ marginTop: "0px" }}><Button color="primary-button" type="button" className="waves-effect waves-light me-1 w-100">
                    <i className=" ri-add-line align-middle me-2"></i>{addButtonTite}
                </Button>
                </Link>
            }

        </>

    );
}
export default (RenderAddButton);
